module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signIn($event)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('svg', {
    staticClass: "name svg-icon",
    attrs: {
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,20 a10,8 0 0,1 20,0z M10,0 a4,4 0 0,1 0,8 a4,4 0 0,1 0,-8"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.username),
      expression: "formData.username"
    }],
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.formData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('svg', {
    staticClass: "pass svg-icon",
    attrs: {
      "viewBox": "0 0 20 20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,20 20,20 20,8 0,8z M10,13 10,16z M4,8 a6,8 0 0,1 12,0"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.password),
      expression: "formData.password"
    }],
    attrs: {
      "type": "password",
      "required": "",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.formData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "提交"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4fd9ca2c"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/SignInForm.vue
// module id = 31
// module chunks = 1